import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('lollipop_lane', {
  cherry: 'swirl_pop',
  lemon: 'marshmallow',
  orange: 'candy_cane_lamp',
  bell: 'cotton_candy',
  star: 'rainbow_pop',
  seven: 'gumball_machine',
  gem: 'jawbreaker',
  scatter: 'pinata',
  money: 'pop_cart',
});

/** Lollipop Lane — GENERATED by scaffoldSlot from
 *  content/slots/lollipop_lane.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const LOLLIPOP_LANE_THEME: Theme = {
  id: 'lollipop_lane',
  name: 'Lollipop Lane',
  palette: {
    accent: 0xff3d9a,
    secondary: 0x35c7e8,
    warm: 0xffd86b,
    frameFill: 0x2a0f33,
    bgGradientTop: 0x3a1248,
    bgGradientBottom: 0x140420,
    dimOverlay: 0x05080d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Swirl Pop', glyph: '🍭', tint: 0xff3d9a, weight: 5, textureAlias: 'lollipop_lane:cherry',
        winVideoAlias: 'lollipop_lane:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Marshmallow', glyph: '☁️', tint: 0xffd0e6, weight: 5, textureAlias: 'lollipop_lane:lemon',
        winVideoAlias: 'lollipop_lane:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Candy-Cane Lamp', glyph: '🏮', tint: 0xff5a5a, weight: 4, textureAlias: 'lollipop_lane:orange',
        winVideoAlias: 'lollipop_lane:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Cotton Candy', glyph: '🌸', tint: 0xff8fd0, weight: 3, textureAlias: 'lollipop_lane:bell',
        winVideoAlias: 'lollipop_lane:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Rainbow Pop', glyph: '⭐', tint: 0xff3d9a, weight: 2, textureAlias: 'lollipop_lane:star',
        winVideoAlias: 'lollipop_lane:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Gumball Machine', glyph: '🔮', tint: 0x35c7e8, weight: 2, textureAlias: 'lollipop_lane:seven',
        winVideoAlias: 'lollipop_lane:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Jawbreaker', glyph: '💎', tint: 0xff8fd0, weight: 2.5, textureAlias: 'lollipop_lane:gem',
        winVideoAlias: 'lollipop_lane:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Star Piñata', glyph: '🎉', tint: 0xff3d9a, weight: 0.5, textureAlias: 'lollipop_lane:scatter',
        winVideoAlias: 'lollipop_lane:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Lollipop Cart', glyph: '🪙', tint: 0xffd86b, weight: 1, textureAlias: 'lollipop_lane:money',
        winVideoAlias: 'lollipop_lane:money:win:video', winVideoSpeed: 2, isMoney: true },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xff3d9a, multiplier: 1, weight: 5 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xffd86b, multiplier: 2, weight: 4 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xff3d9a, multiplier: 1, weight: 5 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x35c7e8, multiplier: 3, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xffd86b, multiplier: 2, weight: 4 },
      { id: 'x1-c', kind: 'multiplier', label: '×1', tint: 0xff3d9a, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xffd86b, multiplier: 5, weight: 2 },
      { id: 'x2-c', kind: 'multiplier', label: '×2', tint: 0xffd86b, multiplier: 2, weight: 3 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0x35c7e8, multiplier: 3, weight: 3 },
      { id: 'x1-d', kind: 'multiplier', label: '×1', tint: 0xff3d9a, multiplier: 1, weight: 4 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xffd86b, multiplier: 5, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xffd86b, multiplier: 10, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'lollipop_lane:bg', path: 'environment/lollipop_lane.png' },
      columnBackground: { alias: 'lollipop_lane:column_bg', path: 'reel/lollipop_lane_column_bg.png' },
      border: { alias: 'lollipop_lane:border', path: 'brand/border_candy.png' },
    },
  },
};
